import { ejectDisk, relieveDevice } from '../services/deviceOp';

export default {
  namespace: 'deviceOp',

  state: {},

  effects: {
    *ejectDisk({ payload, callback }, { call, put }) {
      const res = yield call(ejectDisk, payload);
      callback && callback(res);
    },

    *relieveDevice({ payload, callback }, { call, put }) {
      const res = yield call(relieveDevice, payload);
      callback && callback(res);
    },
  },

  reducers: {},
};
